import { useState, useEffect, useRef, useCallback } from 'react';

// Countdown timer for the assessment. The interval is created once when the
// assessment starts (does NOT depend on timeLeft), and fires onExpire at zero.
export function useAssessmentTimer({ started, submitted, onExpire }) {
  const [timeLeft, setTimeLeft] = useState(0);
  const timerRef = useRef(null);
  const onExpireRef = useRef(onExpire);
  onExpireRef.current = onExpire;

  useEffect(() => {
    if (!started || submitted) return;
    timerRef.current = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timerRef.current);
  }, [started, submitted]);

  // Auto-fire onExpire exactly once when the clock hits zero.
  useEffect(() => {
    if (timeLeft === 0 && started && !submitted) onExpireRef.current?.();
  }, [timeLeft, started, submitted]);

  const clearTimer = useCallback(() => clearInterval(timerRef.current), []);
  return { timeLeft, setTimeLeft, clearTimer };
}
